import React, { useContext, useState, useEffect } from "react";
import "../styles/subShipping.css";
import appConst from "../Utilities/appConst.json";
import { LanguageContext } from "../context/language/LanguageContext";
import {
  fetchAllShopsCollectionPoints,
  shopsActions,
} from "../store/shopsSlice";
import { useDispatch, useSelector } from "react-redux";
import { disableButton, enableButton } from "../Utilities/styleUtil";
import { FloatingLabelAutocomplete } from "./ui/floating-label-autocomplete";
import { getLanguageDirection } from "../Utilities/languageDirection";
import "../styles/personalDetails.css";
import { loaderActions } from "../store/loaderSlice";
import { writeLog } from "../Utilities/logs";

const Shops = (props) => {
  const dispatch = useDispatch();
  const languageContext = useContext(LanguageContext);
  const cities = useSelector((state) => state.shops.cities);
  const collectionPoints = useSelector((state) => state.shops.collectionPoints);
  const isFormSubmited = useSelector((state) => state.shops.isFormSubmited);
  const deliveryDetails = useSelector(
    (state) => state.basket.basket.delivery_details
  );

  const [city, setCityName] = useState(
    deliveryDetails.shop ? deliveryDetails.shop?.city : null
  );
  const [address, setAddress] = useState("");
  const [site, setSiteName] = useState(
    deliveryDetails.shop ? deliveryDetails.shop?.site : null
  );
  const [showCityError, setShowCityError] = useState(
    !deliveryDetails.shop?.city
  );
  const [showCollectingPointsError, setShowCollectingPointsError] = useState(
    !deliveryDetails.shop?.site
  );

  useEffect(() => {
    disableButton(dispatch);
    dispatch(loaderActions.loaderShow());
  }, []);

  useEffect(() => {
    if (cities.length > 0) {
      dispatch(loaderActions.loaderHide());
    }
  }, [cities]);

  const isKnownCity = (name) => !!name && cities.some((item) => item === name);

  const findCollectionPoint = (name) =>
    collectionPoints.find((collectionPoint) => collectionPoint.SiteName === name);

  const resetSite = () => {
    setSiteName("");
    setAddress("");
    setShowCollectingPointsError(true);
    dispatch(shopsActions.setSite({ site: "" }));
    dispatch(shopsActions.setSiteId({ siteId: -1 }));
    dispatch(shopsActions.setIsValid({ isValid: false }));
    disableButton(dispatch);
  };

  // Keeps whatever was typed so the field stays searchable; only an exact
  // option match is committed to the store.
  const setCity = (typedCity) => {
    const cityChanged = typedCity !== city;
    const isValidCity = isKnownCity(typedCity);

    setCityName(typedCity);
    setShowCityError(!isValidCity);

    if (cityChanged) {
      resetSite();
      dispatch(shopsActions.setCity({ city: isValidCity ? typedCity : "" }));
      if (isValidCity) {
        dispatch(fetchAllShopsCollectionPoints(typedCity));
      } else {
        dispatch(shopsActions.setCollectionPoints({ payload: [] }));
      }
    }

    writeLog({ message: `message: city is set to: ${typedCity}` });
  };

  const setSite = (typedSite) => {
    const collectionPoint = findCollectionPoint(typedSite);

    setSiteName(typedSite);
    setShowCollectingPointsError(!collectionPoint);

    if (collectionPoint) {
      setAddress(collectionPoint.Address);
      dispatch(shopsActions.setSite({ site: typedSite }));
      dispatch(shopsActions.setSiteId({ siteId: collectionPoint.SiteId }));
      dispatch(shopsActions.setIsValid({ isValid: isKnownCity(city) }));
      if (isKnownCity(city)) {
        enableButton(dispatch);
      } else {
        disableButton(dispatch);
      }
    } else {
      setAddress("");
      dispatch(shopsActions.setSite({ site: "" }));
      dispatch(shopsActions.setSiteId({ siteId: -1 }));
      dispatch(shopsActions.setIsValid({ isValid: false }));
      disableButton(dispatch);
    }

    writeLog({ message: `message: site is set to: ${typedSite}` });
  };

  const fieldDirection = getLanguageDirection(languageContext.language?.id);
  const noOptionsText = languageContext.getTranslation(
    appConst.VALIDATION_TEXT_NOT_ON_THE_LIST
  );

  return (
    <div className="shops page personal_details sub_shipping_selects text-start mt-6">
      <div className="selections">
        <div className="selection">
          <FloatingLabelAutocomplete
            id="shipping-shops-city"
            label={languageContext.getTranslation(appConst.SELECT_CITY)}
            required
            invalid={isFormSubmited && showCityError}
            errorText={
              isFormSubmited && showCityError
                ? languageContext.getTranslation(
                    appConst.VALIDATION_SELECT_CITY_REQUIRED_FIELD
                  )
                : undefined
            }
            dir={fieldDirection}
            value={city || ""}
            options={cities.filter((city) => city != "")}
            onValueChange={setCity}
            noOptionsText={noOptionsText}
            filterFromStart
            dataTestId="shipping-shops-city"
          />
        </div>
        <div className="selection">
          <FloatingLabelAutocomplete
            id="shipping-shops-collection-point"
            label={languageContext.getTranslation(appConst.SELECT_COLLECTING_POINT)}
            required
            invalid={isFormSubmited && showCollectingPointsError}
            errorText={
              isFormSubmited && showCollectingPointsError
                ? languageContext.getTranslation(
                    appConst.VALIDATION_SELECT_COLLECTING_POINT_REQUIRED_FIELD
                  )
                : undefined
            }
            disabled={showCityError}
            dir={fieldDirection}
            value={site || ""}
            options={collectionPoints.map(
              (collectionPoint) => collectionPoint.SiteName
            )}
            onValueChange={setSite}
            noOptionsText={noOptionsText}
            dataTestId="shipping-shops-collection-point"
          />
        </div>
      </div>
      <div className="address_container">
        {address && (
          <div className="address text-start" data-testid="shipping-shops-address">
            <p>{languageContext.getTranslation(appConst.ADDRESS)}:</p>
            <p>{address}</p>
          </div>
        )}
      </div>
    </div>
  );
};
export default Shops;
